import {az} from './az'
import {en} from './en'
import {hu} from "./hu"
import {ko} from "./ko"
import {pt} from "./pt"
import {ru} from './ru'
import {tr} from './tr'
import {uz} from './uz'

import {Environment} from '../config/Environment'
import {deepMerge} from '../deepMerge'

const lang = {
  az,
  en,
  hu,
  ko,
  pt,
  ru,
  tr,
  uz,
}

// Country codes sometimes sent instead of language codes.
const aliases = {
  kr: 'ko',
}

function resolveAlias(code) {
  return aliases[code] || code
}

const envKeys = Object.keys(Environment).filter(key => key.includes('REACT_APP_TRANSLATE_'))

envKeys.forEach(envKey => {
  const code = resolveAlias(envKey.replace('REACT_APP_TRANSLATE_', '').toLowerCase())
  try {
    const json = JSON.parse(Environment[envKey]?.replaceAll("'", '"'))
    lang[code] = deepMerge(lang[code], json)
  } catch (e) {
    //
  }
})

export function fixLanguageList(list) {
  return [...new Set(list.map(resolveAlias))].filter(l => lang[l])
}

export function fixLanguage(str) {
  const tag = resolveAlias(str.toLocaleString())
  if (lang[tag]) {
    return tag
  }
  return resolveAlias(Environment.REACT_APP_DEFAULT_LANGUAGE || 'en')
}

export {lang}
